<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="content-modal-container">
                <div class="export-modal-header">
                    <div class="modal-title">
                        Экспорт {{ this.fileName.toLowerCase() }}
                    </div>

                    <div class="modal-header__close-button" @click="hideExportModal">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18M6 6L18 18" stroke="#A8A8A8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>

                <div class="modal-body">
                    <div class="modal-body__input">
                        <div v-for="filter in localFilters">
                            <v-select
                                v-if="filter.type === 'select'"
                                :label="filter.name"
                                v-model="filter.model"
                                :items="filter.options"
                                :item-title="filter.title"
                                item-value="id"
                                variant="outlined"
                                color="primary"
                                density="compact"
                                clearable
                                @update:menu="$removeFocus"
                                @click:clear="$removeFocus"
                                @click:control="$removeFocus">
                                <template #no-data>
                                    <v-list-item>
                                        <span>Данные не найдены</span>
                                    </v-list-item>
                                </template>
                            </v-select>

                            <div v-else-if="filter.type === 'date'">
                                <input v-model="filter.model"
                                       class="form-control"
                                       type="date">
                            </div>

                            <div v-else-if="filter.type === 'time'">
                                <input v-model="filter.model"
                                       class="form-control"
                                       type="time">
                            </div>

                            <div v-else-if="filter.type === 'interval'">
                                <div class="time-interval-inputs">
                                    <input type="time" class="form-control" placeholder="От" v-model="filter.model.from">
                                    <input type="time" class="form-control" placeholder="До" v-model="filter.model.to">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="log-export-modal-footer">
                    <button @click="downloadReport" :disabled="isButtonDisabled" class="btn btn-md btn-primary me-2" type="button">
                        <span>Выгрузить</span>
                    </button>
                </div>
                <Transition name="fade">
                    <v-progress-circular
                        v-if="loading"
                        :model-value="progress"
                        :rotate="360"
                        :size="65"
                        :width="8"
                    >
                        <template v-slot:default> {{ progress }} % </template>
                    </v-progress-circular>
                </Transition>
            </div>
        </div>
    </div>
    <Alert />
</template>

<script>
import { mapMutations } from 'vuex/dist/vuex.cjs.js';
import Alert from "../components/alerts/Alert.vue";
export default {
    name: 'ExportModal',
    components: {
        Alert
    },
    props: {
        filters: {
            type: Array, required: true
        },
        routeExport: {
            type: String,
        },
        fileName: {
            type: String,
            default: ''
        },
        format: {
            type: String,
            default: '.xlsx'
        },
    },
    data() {
        return {
            localFilters: JSON.parse(JSON.stringify(this.filters)),
            loading: false,
            isButtonDisabled: false,
            progress: 0
        };
    },
    methods: {
        ...mapMutations(
            'logs',
            ['hideExportModal', 'setExportParams', 'showExportModal']
        ),
        ...mapMutations(
            'alerts',
            ['addAlert']
        ),
        getParams() {
            return this.localFilters.reduce((acc, filter) => {
                acc[filter.key] = filter.model !== null ? filter.model : 0;
                return acc;
            }, {});
        },
        async downloadReport() {
            this.loading = true;
            this.isButtonDisabled = true;
            const params = this.getParams();

            const data = await axios.get(
                this.routeExport,
                {
                    params,
                    responseType: "blob"
                }
            );

            if (data.data.status == 'error') {
                this.loading = false;
                this.isButtonDisabled = false;
                this.addAlert({ type: 'info', title: 'Уведомление', text: data.data.message });
            } else {
                let interval = setInterval(() => {
                    if (this.progress < 90) this.progress += Math.floor(Math.random() * 5 + 7);
                }, 500);

                try {
                    // Создаем объект ссылки для скачивания
                    const url = window.URL.createObjectURL(new Blob([data.data]));
                    const link = document.createElement("a");
                    link.href = url;

                    link.setAttribute(
                        "download",
                        `${new Date().toLocaleString().replace(',','')}` + '_' + this.fileName + this.format
                    );

                    // Добавляем ссылку в DOM и запускаем ее клик
                    document.body.appendChild(link);
                    link.click();

                    // Удаляем ссылку после завершения
                    link.remove();
                    URL.revokeObjectURL(url);
                    setTimeout(() => {
                        this.loading = false;
                        this.isButtonDisabled = false;
                        clearInterval(interval);
                        this.hideExportModal();
                    }, 100);
                } catch (error) {
                    console.error("Ошибка при загрузке файла:", error);
                }
            }
        },
        clearSelects() {
            this.localFilters.forEach(filter => {
                if (typeof filter.model === 'object' && filter.model !== null) {
                    if ('from' in filter.model || 'to' in filter.model) {
                        filter.model.from = null;
                        filter.model.to = null;
                    } else {
                        filter.model = null;
                    }
                } else {
                    filter.model = null;
                }
            });
        }
    },
    mounted() {
        this.clearSelects();
    }
}

</script>

<style scoped lang="scss">
.time-interval-inputs {
    display: flex;
    gap: 12px;
}
</style>
